import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Tarilonte
 * id DBF95B71-CC94-4672-8356-A09B96644694
 * name warehouse
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/warehouse.svg
 * tags
 * - Places 
 */
export const WarehouseIcon = createSvgIcon(<><path d="M6 19H8V21H6V19M12 3L2 8V21H4V13H20V21H22V8L12 3M8 11H4V9H8V11M14 11H10V9H14V11M20 11H16V9H20V11M6 15H8V17H6V15M10 15H12V17H10V15M10 19H12V21H10V19M14 19H16V21H14V19Z" /></>, 'WarehouseIcon');
export default WarehouseIcon